import { useContext, useEffect, useState } from 'react';
import UserContext from '../../../context/userContext';
import { Button, Heading, Alert, AlertIcon } from '@chakra-ui/react';
import { Loading } from '../../Common/Loading';
import TablaSociosPost from './TablaSociosPost';

import { filtrarCabana } from '../../../services/filtrarCabana';
import { filtrarTitulares } from '../../../services/filtrarTitulares';
import { obtenerTitularesPost } from '../../../services/obtenerTitularesPost';
import '../../../styles/socios.scss';
import { useTranslation } from 'react-i18next';

export default function MostrarSociosPost() {

  const { t } = useTranslation();

  const { user, isLoadingContext, setIsLoadingContext } =
    useContext(UserContext);
  const [socios, setSocios] = useState([]);
  const [search, setSearch] = useState('');
  const [error, setError] = useState({ error: false, msg: '' });

  const handleTitulares = (id) => {
    setIsLoadingContext(true);
    obtenerTitularesPost(id)
      .then((res) => {
        if (res.status === 200) {
          setSocios(res.data.titulares);
        } else {
          setError({ error: true, msg: 'Error obteniendo titulares' });
        }
      })
      .catch((err) => {
        setError({ error: true, msg: 'Error obteniendo usuarios.' });
      })
      .finally(() => setIsLoadingContext(false));
  };

  useEffect(() => {
    if (search.length === 0) {
      setIsLoadingContext(true);
      handleTitulares(user.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, user.id]);

  const handleSearchTerm = (e) => {
    setSearch(e.target.value);
    setError({ error: false, msg: '' });
  };

  const containsSpecialCharacters = (text) => {
    const regex = /^[^{}[\]#&%!¡"()='?;:,.¿+~¨´`|¬°*$\\^/]*$/;
    return !regex.test(text);
  };

  const containsSpaces = (text) => {
    return text.includes(' ');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim() === '') {
      setError({
        error: true,
        msg: t('NO_SPACES_ALLOWED'),
      });
      return;
    } else if (containsSpecialCharacters(search)) {
      setError({ error: true, msg: t('NO_SPECIAL_CHARACTERS') });
      return;
    } else if (containsSpaces(search)) {
      setError({ error: true, msg: t('NO_SPACES_ALLOWED') });
      return;
    }

    setIsLoadingContext(true);
    filtrarTitulares(user.id, search)
      .then((res) => {
        if (res.status === 200) {
          setSocios(res.data.users);
          setError({ error: false, msg: '' });
        } else {
          setError({ error: true, msg: t('ERROR_FILTERING_USERS'), });
        }
        setIsLoadingContext(false);
      })
      .catch((err) =>
        setError({ error: true, msg: t('ERROR_FETCHING_USERS') })
      );
  };

  const handleFiltrarCabana = (e, cabana) => {
    e.preventDefault();
    setIsLoadingContext(true);
    filtrarCabana(user.id, cabana)
      .then((res) => {
        if (res.status === 200) {
          setSocios(res.data.users);
          setError({ error: false, msg: '' });
        } else {
          setError({ error: true, msg: 'Error filtrando usuarios' });
        }
        setIsLoadingContext(false);
      })
      .catch((err) =>
        setError({ error: true, msg: 'Error obteniendo usuarios.' })
      );
  };

  return (
    <div className="p-5">
      <div className="d-flex justify-content-between">
        <div>
          <Heading
            as="h3"
            size="lg"
          >
            {t('FILTER_MEMBER_POST')}
          </Heading>
          <p className="my-2">
            {t('ENTER_USER_INFO')}
          </p>

          <form className="d-flex justify-content-between my-3">
            <input
              className="form-control me-3"
              type="text"
              onChange={handleSearchTerm}
            />
            <Button
              colorScheme={'blue'}
              type="submit"
              onClick={handleSearch}
            >
              {t('SEARCH')}
            </Button>
          </form>
          {error.error && (
            <Alert status="error">
              <AlertIcon />
              {error.msg}
            </Alert>
          )}
        </div>
        <div>
          <Heading
            as="h3"
            size="lg"
          >
            {t('CABIN_TYPE')}:
          </Heading>
          <div className="d-flex my-5">
            <Button
              mx={2}
              colorScheme={'orange'}
              onClick={(e) => handleFiltrarCabana(e, 'MEZQUITE')}
            >
              {t('MEZQUITE')}
            </Button>
            <Button
              mx={2}
              colorScheme={'orange'}
              onClick={(e) => handleFiltrarCabana(e, 'PIRUL')}
            >
              {t('PIRUL')}
            </Button>
            <Button
              mx={2}
              colorScheme={'orange'}
              onClick={(e) => handleFiltrarCabana(e, 'BAMBU')}
            >
              {t('BAMBU')}
            </Button>
            <Button
              mx={2}
              colorScheme={'purple'}
              onClick={() => handleTitulares(user.id)}
            >
              {t('ALL')}
            </Button>
          </div>
        </div>
      </div>
      <div className="w-100 mt-5">
        {isLoadingContext ? <Loading /> : <TablaSociosPost socios={socios} />}
      </div>
    </div>
  );
}
